import React, { useState, useEffect } from "react";
import Footer from "../component/Footer";
import "../Text Modification Formatting/text.css";

const RandomMonthGenerator = () => {
  const [month, setMonth] = useState("");
  const [textStatistics, setTextStatistics] = useState({
    wordCount: 0,
    letterCount: 0,
    sentenceCount: 0,
    lineCount: 0,
  });

  const months = [
    "January", "February", "March", "April", "May", "June", 
    "July", "August", "September", "October", "November", "December"
  ];

  const generateRandomMonth = () => {
    return months[Math.floor(Math.random() * months.length)];
  };

  const calculateTextStatistics = (text) => {
    const words = text.trim().split(/\s+/).filter((word) => word.length > 0);
    const letters = text.replace(/\s+/g, "").length;
    const sentences = text.split(/[.!?]+/).filter((sentence) => sentence.trim().length > 0);
    const lines = text.split("\n").length;
    return {
      wordCount: words.length,
      letterCount: letters,
      sentenceCount: sentences.length,
      lineCount: lines,
    };
  };

  const handleRandomise = () => {
    const randomMonth = generateRandomMonth();
    setMonth(randomMonth);
    const statistics = calculateTextStatistics(randomMonth);
    setTextStatistics(statistics);
  };

  const handleDownload = (text, fileName) => {
    const element = document.createElement("a");
    const file = new Blob([text], { type: "text/plain" });
    element.href = URL.createObjectURL(file);
    element.download = fileName;
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
  };

  const handleClear = () => {
    setMonth("");
    setTextStatistics({
      wordCount: 0,
      letterCount: 0,
      sentenceCount: 0,
      lineCount: 0,
    });
  };

  useEffect(() => {
    handleRandomise();
  }, []);

  return (
    <div className="container">
      <main>
        <h1>Rabbit Case</h1>
        <div className="content">
          <h2>Random Month Generator</h2>
          <p>
            Your go-to tool for selecting months at random. Whether you're
            planning future events, making decisions, or just need a random
            pick, this tool simplifies the process.
          </p>
          <div className="textarea-container">
            <textarea
              className="textarea-animated"
              placeholder="Month"
              rows="6"
              readOnly
              value={month}
            />
          </div>
          <br />
          <div className="btn-container" >
            <button class="btn-421" onClick={handleRandomise}>Randomise</button>
            <button class="btn-421" onClick={() => handleCopy(month)}>Copy to Clipboard</button>
            <button class="btn-421" onClick={handleClear}>Clear</button>
          </div>
         
        </div>
        <br />
        <div className="content1">
          <h3>How the Random Month Generator Works</h3>
          <p>
            The random month generator tool selects a month at random from
            January to December. This tool is perfect for a variety of uses,
            from planning projects, assigning tasks with no specific deadlines,
            or even educational purposes. It eliminates bias and ensures a fair
            selection, making decision-making processes smoother and more
            straightforward.
          </p>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default RandomMonthGenerator;
